import React from 'react';
import '../styles/SaveStrategyModal.css';

const MirrorSubmissionModals = ({
  showMirrorConfirm,
  showMirrorEdit,
  showDeleteConfirm,
  linkedNoticeType,
  hideLinkedSubmissionNotice,
  onConfirmMirror,
  onCancelMirror,
  onCloseMirrorEdit,
  onToggleHideLinkedNotice,
  onConfirmDelete,
  onCancelDelete,
  isDeleting,
}) => (
  <>
    {showMirrorConfirm && (
      <div className="modal-overlay">
        <div className="save-modal" style={{ maxWidth: '520px' }}>
          <h2>Confirm Mirror Submission</h2>
          <p>
            Two linked submissions will be created: one for your team and one for the opponent.
            Both will be saved atomically in the same season.
          </p>
          <div className="modal-actions">
            <button className="cancel-button" onClick={onCancelMirror}>
              Cancel
            </button>
            <button className="confirm-button" onClick={onConfirmMirror}>
              Create Both
            </button>
          </div>
        </div>
      </div>
    )}

    {showMirrorEdit && (
      <div className="modal-overlay">
        <div className="save-modal" style={{ maxWidth: '520px' }}>
          <h2>Linked Submission</h2>
          {linkedNoticeType === 'teamSummary' ? (
            <p>
              This enemy scouting record is linked to a Team Summary submission. When you save
              changes here, the linked Team Summary will be updated automatically.
            </p>
          ) : (
            <p>
              This record is linked to a mirror submission. When you save changes, the mirror
              record will be updated automatically.
            </p>
          )}
          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginTop: '10px',
              color: '#b0b0b0',
              fontSize: '0.92rem'
            }}
          >
            <input
              type="checkbox"
              checked={!!hideLinkedSubmissionNotice}
              onChange={(e) => onToggleHideLinkedNotice && onToggleHideLinkedNotice(e.target.checked)}
            />
            Don&apos;t show again
          </label>
          <div className="modal-actions">
            <button className="confirm-button" onClick={onCloseMirrorEdit}>
              OK
            </button>
          </div>
        </div>
      </div>
    )}

    {showDeleteConfirm && (
      <div className="modal-overlay">
        <div className="save-modal" style={{ maxWidth: '520px' }}>
          <h2>Delete Submission</h2>
          <p>
            This will delete the current submission. If it has a linked reciprocal/mirror record,
            that linked record will also be deleted.
          </p>
          <div className="modal-actions">
            <button className="cancel-button" onClick={onCancelDelete} disabled={isDeleting}>
              Cancel
            </button>
            <button className="confirm-button" onClick={onConfirmDelete} disabled={isDeleting}>
              Delete
            </button>
          </div>
        </div>
      </div>
    )}
  </>
);

export default MirrorSubmissionModals;
